import { Star, BadgeCheck } from "lucide-react";
import { Reveal, Kicker } from "./Reveal";

const REVIEWS = [
  {
    text: "Sunnys converted our loft in eight weeks flat. Clean site every evening, a clear fixed quote, and the finish is superb — the skylights have changed how the whole house feels.",
    name: "Priya Sharma",
    location: "Hounslow",
    source: "Google",
    project: "Loft Conversion",
  },
  {
    text: "Our double-storey extension was project-managed brilliantly. One point of contact, weekly updates, and it came in on the quoted price. Couldn't ask for more.",
    name: "Mark Turner",
    location: "Ealing",
    source: "Checkatrade",
    project: "Extension",
  },
  {
    text: "They re-roofed our 1930s semi — new tiles, leadwork and guttering. The crew were polite, tidy and clearly take pride in their work. Highly recommended.",
    name: "Elaine Ward",
    location: "Richmond",
    source: "Checkatrade",
    project: "Roofing",
  },
  {
    text: "Full kitchen strip-out and refit in five weeks. Electrics, plumbing, tiling all handled in-house — no chasing separate trades. The brick feature wall gets compliments daily.",
    name: "Daniel Kim",
    location: "Chiswick",
    source: "Google",
    project: "Kitchen Renovation",
  },
];

const Stars = () => (
  <div className="flex gap-1">
    {[...Array(5)].map((_, i) => (
      <Star key={i} className="h-4 w-4 fill-bronze text-bronze" />
    ))}
  </div>
);

export const Testimonials = () => (
  <section
    id="testimonials"
    data-testid="testimonials-section"
    className="bg-white py-24 md:py-36"
  >
    <div className="mx-auto max-w-7xl px-6">
      <div className="flex flex-col justify-between gap-8 md:flex-row md:items-end">
        <div>
          <Reveal>
            <Kicker index="06" label="Testimonials" />
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-6 font-display text-5xl font-bold uppercase tracking-tight text-ink md:text-6xl">
              Rated by <span className="text-gold-shine">Homeowners</span>
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.15}>
          <div className="flex items-center gap-4 border border-black/10 bg-coal px-6 py-4">
            <span className="font-display text-4xl font-extrabold text-ink">4.9</span>
            <div>
              <Stars />
              <p className="mt-1 text-[11px] uppercase tracking-[0.2em] text-black/50">
                Google &amp; Checkatrade
              </p>
            </div>
          </div>
        </Reveal>
      </div>

      <div className="mt-16 grid gap-px border border-black/10 bg-black/10 sm:grid-cols-2 lg:grid-cols-4">
        {REVIEWS.map((review, i) => (
          <Reveal key={review.name} delay={i * 0.08} className="h-full">
            <figure
              data-testid={`review-card-${i + 1}`}
              className="flex h-full flex-col bg-white p-7 transition-colors duration-500 hover:bg-steel"
            >
              <Stars />
              <blockquote className="mt-5 flex-1 text-sm leading-relaxed text-ink/80">
                "{review.text}"
              </blockquote>
              <figcaption className="mt-6 border-t border-black/5 pt-5">
                <div className="flex items-center justify-between gap-3">
                  <div>
                    <div className="text-sm font-semibold text-ink">{review.name}</div>
                    <div className="mt-0.5 text-[11px] uppercase tracking-[0.2em] text-black/50">
                      {review.location} · {review.project}
                    </div>
                  </div>
                  <span className="flex shrink-0 items-center gap-1.5 border border-bronze/40 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.15em] text-bronze">
                    <BadgeCheck className="h-3 w-3" />
                    {review.source}
                  </span>
                </div>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
